import { COMMENT_AND_TAGS_UPDATE_ASYNC, MODAL_CLOSE, MODAL_OPEN } from './constants'

export default function () {
  const initialState = {
    data: null, // modal is open if data exists
    loader: false,
    error: null,
    showExplanation: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case MODAL_OPEN:
        return {
          ...state,
          data: { ...action.data },
          showExplanation: false,
          error: null,
        }
      case MODAL_CLOSE:
        return { ...state, data: null }
      case COMMENT_AND_TAGS_UPDATE_ASYNC.INITIATE:
        return { ...state, loader: true }
      case COMMENT_AND_TAGS_UPDATE_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          loader: false,
          showExplanation: true,
        }
      case COMMENT_AND_TAGS_UPDATE_ASYNC.ERROR:
        return {
          ...state,
          loader: false,
          error: action.error,
        }
      case COMMENT_AND_TAGS_UPDATE_ASYNC.CANCEL:
        return { ...state, loader: false }
      default:
        return state
    }
  }
}
